import {Decimal} from 'decimal.js';

// The default 20 significant digits would round a 13-digit price before its own HALF_UP step.
const PriceDecimal = Decimal.clone({precision: 40, rounding: Decimal.ROUND_HALF_UP});
const NET_DECIMALS = 4;
const GROSS_DECIMALS = 2;
const ZEROS_BEYOND_TWO_DECIMALS = /(\.\d{2}\d*?)0+$/;

const vatMultiplier = (rate: string) => new PriceDecimal(rate).div(100).plus(1);

export const trimPriceDecimals = (amount: string) =>
  amount.replace(ZEROS_BEYOND_TWO_DECIMALS, '$1');

export const netFromGross = (gross: string, rate: string) =>
  trimPriceDecimals(new PriceDecimal(gross).div(vatMultiplier(rate)).toFixed(NET_DECIMALS));

export const grossFromNet = (net: string, rate: string) =>
  new PriceDecimal(net).mul(vatMultiplier(rate)).toFixed(GROSS_DECIMALS);
